import { throttle } from "../tools"

function adjustH3FontSize(elClass: string, minSize: number, maxSize: number) {
    let els = Array.from(document.getElementsByClassName(elClass) as HTMLCollectionOf<HTMLElement>);
    for (const el of els) {
        let headers = Array.from(el.getElementsByTagName('h3') as HTMLCollectionOf<HTMLElement>);
        for (const header of headers) {
            let size = Math.min(Math.max(minSize, el.clientWidth / 20), maxSize);
            header.style.fontSize = `${size}px`;
        }
    }
}

function adjustConsultIcon() {
    let consults = Array.from(document.getElementsByClassName('consulting') as HTMLCollectionOf<HTMLElement>);
    for (const consult of consults) {
        let content = consult.getElementsByClassName('content')[0] as HTMLElement;
        let button = consult.getElementsByClassName('button')[0] as HTMLElement;
        let svg = consult.getElementsByTagName('svg')[0];
        if (consult.clientWidth - 77.05 >= content.clientWidth + button.clientWidth + 20)
            svg.style.display = 'none';
        else
            svg.style.display = null;
    }
}

export function widthControllerInit() {
    let adjustPromsH3Width = () => adjustH3FontSize('promotion', 18, 32);
    adjustPromsH3Width();
    window.addEventListener('resize', throttle(adjustPromsH3Width, 500));

    let adjustConsultsH3Width = () => adjustH3FontSize('consulting', 18, 32);
    adjustConsultsH3Width();
    window.addEventListener('resize', throttle(adjustConsultsH3Width, 500));

    adjustConsultIcon();
    window.addEventListener('resize', throttle(adjustConsultIcon, 500));
}